module.exports = new __parcel__URL__("wmms-blk.b3517029.svg").toString();